<template>
    <div class="inner-box">
        <div class="title">개인정보 처리방침</div>
        <div class="title-s">방문 예약 시스템의 개인정보 처리방침입니다.</div>

        <h1>개인정보 처리방침</h1>
        <table class="visit-info-table">
            <tr>
                <td>
                    <div>

                    </div>
                </td>
            </tr>
        </table>

        <div style="height:50px"></div>

        <div class="btn">
            <button v-on:click="main()">메인홈</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "policy",
        data(){
            return {

            }
        },
        methods: {
            main(){
                this.$router.push({path: `/`});
            }
        },
        created(){

        }
    }
</script>

<style scoped>
    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
        padding:0px 0;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box button:first-child{
        background-color: #b3b3b3;
        color:#fff;
    }

    .inner-box .btn{
        text-align:center;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }
</style>